// All about page content is here!

export const about = {
    resources: [
        'https://www.pdq.com/powershell/',
        'https://ss64.com/ps/',
        'https://docs.microsoft.com/en-us/powershell/'
    ],
    powerShellCheatSheet: {
        version: '0.0.9'
    },
    repository: 'https://github.com/ayoubmazouz/powershell-cheat-sheet',
}